import React, { useState, useRef, useEffect } from "react";
import "./Select.css";
import "./SelectItem";
import SelectItem from "./SelectItem";
import {additionLuvers ,additionWindow} from "./additionSelects";
function SelectList(props: any) {
  const ref = useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    const onDispatchHandler = (e: Event) => {
      props.onSelectChange(e);
    };
    if (ref.current && props.konfigured[props.category] === undefined) {
      const event = new Event("change");
      ref.current.addEventListener("change", onDispatchHandler);
      ref.current.dispatchEvent(event);
      return () => {
        if (ref.current)
          ref.current.removeEventListener("change", onDispatchHandler);
      };
    }
  }, [props.category, props.konfigured]);


  const renderList = (value: null | {}[]) => {
    if (value == null) return;
    return value.map((el: any, i: number) => (
      <li className="Select-item" key={el.id}>
        <SelectItem
          ref={i === 0 ? ref : null}
          id={el.id}
          konfigured={props.konfigured}
          onSelectChange={props.onSelectChange}
          category={props.category}
          name={`${props.category}`}
          el={el}
        ></SelectItem>
      </li>
    ));
  };

  const additionLuversList = () => {
    return additionLuvers.map((el: any, i: number) => (
      <li className="Select-item" key={el.id}>
        <SelectItem
          id={el.id}
          konfigured={props.konfigured}
          onSelectChange={props.onSelectChange}
          category={props.category}
          name={`${props.category}`}
          el={el}
        ></SelectItem>
      </li>
    ));
  };

  const additionWindowList = () => {
    return additionWindow.map((el: any, i: number) => (
      <li className="Select-item" key={el.id}>
        <SelectItem
          id={el.id}
          konfigured={props.konfigured}
          onSelectChange={props.onSelectChange}
          category={props.category}
          name={`${props.category}`}
          el={el}
        ></SelectItem>
      </li>
    ));
  };

  return (
    <div className="SelectList">
        <ul className="Select-list">
          {renderList(props.selects)}
          {props.category === "luvers" ? additionLuversList() : "  "}
          {props.category === "window" ? additionWindowList() : "  "}
        </ul>
    </div>
  );
}

export default SelectList;
